import React, { useEffect, useState } from 'react';
import { Box, Typography, useMediaQuery, Fade } from '@mui/material';
import logo from '../assets/rounded_logo.svg';

interface BrandingSectionProps {
  children?: React.ReactNode;
  animatedTaglines?: boolean;
  customTaglines?: string[];
}

const BrandingSection: React.FC<BrandingSectionProps> = ({
  children,
  animatedTaglines = false,
  customTaglines = [
    "Tenant search, simplified.",
  ]
}) => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const [currentTagline, setCurrentTagline] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!animatedTaglines) return;

    const interval = setInterval(() => {
      setVisible(false);

      setTimeout(() => {
        setCurrentTagline((prev) => (prev === 0 ? 1 : 0));
        setVisible(true);
      }, 500);
    }, 6000);

    return () => clearInterval(interval);
  }, [animatedTaglines]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      {/* Logo */}
      <Box
        component="img"
        src={logo}
        alt="Heyy Property Logo"
        sx={{
          width: isMobile ? '200px' : '375px',
          height: 'auto',
          marginBottom: 4,
          alignSelf: 'center',
        }}
      />

      {/* Tagline */}
      {animatedTaglines ? (
        <Fade in={visible} timeout={500}>
          <Typography
            variant="h6"
            sx={{
              mt: '2rem',
              color: "black",
              textAlign: 'center',
              fontWeight: 450,
              fontSize: { xs: '1.2rem', sm: '1.50rem' },
              lineHeight: 1.3,
              minHeight: '3rem',
            }}
          >
            {customTaglines[currentTagline]}
          </Typography>
        </Fade>
      ) : (
        <Typography
          variant="h6"
          sx={{
            mt: '2rem',
            color: "black",
            textAlign: 'center',
            fontWeight: 450,
            fontSize: { xs: '1.2rem', sm: '1.50rem' },
            lineHeight: 1.3,
            minHeight: '3rem',
          }}
        >
          {customTaglines[0]}
        </Typography>
      )}

      {/* CTA Button Container */}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: '2rem',
          '& > *': {
            width: isMobile ? '60%' : '320px',
            maxWidth: isMobile ? '60%' : '320px',
          }
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default BrandingSection;